import React, { useEffect, useState } from "react";
// import { getLessonById, updateLesson } from "@/service/lesson.services";
import { useNavigate, useParams } from "react-router-dom";

import Layout from "@components/layout";
import { getFromMemory } from "@utils/storage.utils";
import showToast from "@utils/toast";
import { updateLevel } from "./../../types";

type ILevel = Partial<updateLevel>;

const EditLevelForm = () => {
  const levelId = getFromMemory("levelId") || null;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [level, setLevel] = useState<ILevel>({
    title: "",
    description: "",
    level: "",
    language: "",
    image: "",
    icon: "",
    completedLessons: 0,
    totalLessons: 0,
    locked: false,
  });

  //   useEffect(() => {
  //     const fetchLevel = async () => {
  //       try {
  //         const res = await getLevelById(levelId as string);
  //         if (res?.status === "success") {
  //           setLevel(res.result);
  //         } else {
  //           showToast("Level not found", false);
  //         }
  //       } catch (err) {
  //         showToast("Failed to load level", false);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchLevel();
  //   }, [levelId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setLevel((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = () => {
    setLevel((prev) => ({ ...prev, locked: !prev.locked }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = { status: "success" }; // await updateLevel(levelId as string, level);
      if (res.status === "success") {
        showToast("Level updated successfully", true);
        navigate("/dashboard/levels");
      } else {
        showToast("Failed to update level", false);
      }
    } catch (err) {
      showToast("Error updating level", false);
    }
  };

  if (loading) return <p className="text-center p-4">Loading level...</p>;

  return (
    <Layout>
      <form
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-lg space-y-5 mt-4"
      >
        <h2 className="text-xl font-semibold text-gray-800">Edit Level</h2>

        <input
          name="title"
          value={level.title}
          onChange={handleChange}
          placeholder="Level Title"
          className="input-style"
        />
        <textarea
          name="description"
          value={level.description}
          onChange={handleChange}
          rows={3}
          placeholder="Level Description"
          className="input-style"
        />

        <input
          name="image"
          value={level.image}
          onChange={handleChange}
          placeholder="Image URL"
          className="input-style"
        />
        <input
          name="icon"
          value={level.icon}
          onChange={handleChange}
          placeholder="Icon URL"
          className="input-style"
        />

        <div className="grid grid-cols-2 gap-4">
          <input
            name="level"
            value={level.level}
            onChange={handleChange}
            placeholder="Level (e.g. A1)"
            className="input-style"
          />
          <input
            name="language"
            value={level.language}
            onChange={handleChange}
            placeholder="Language"
            className="input-style"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <input
            name="completedLessons"
            type="number"
            value={level.completedLessons}
            onChange={handleChange}
            placeholder="Completed Lessons"
            className="input-style"
          />
          <input
            name="totalLessons"
            type="number"
            value={level.totalLessons}
            onChange={handleChange}
            placeholder="Total Lessons"
            className="input-style"
          />
        </div>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            checked={level.locked}
            onChange={handleCheckbox}
            className="form-checkbox text-brand"
          />
          <span className="text-sm text-gray-700">Locked</span>
        </label>

        <button type="submit" className="button-primary">
          Save Changes
        </button>
      </form>
    </Layout>
  );
};

export default EditLevelForm;
